//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
//import wrapCsvValue from "../../mixins/wrapCsvValue";
import router from "../../router";

export default {
  mixins: ["wrapCsvValue"],
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "ProductNumber",
        descending: false,
      },
      columns: [
        {
          name: "ProductNumber",
          align: "left",
          label: this.$t("products.productNo"),
          field: "productNumber",
          style: "width: 300px",
          sortable: true,
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("products.name"),
          field: "productName",
          style: "width: 400px",
          sortable: true,
        },
        {
          name: "ProductDescription",
          align: "left",
          label: this.$t("products.description"),
          field: "productDescription",
          sortable: true,
        },

        {
          name: "supplierName",
          align: "left",
          label: this.$t("products.supplier"),
          field: "supplierName",
          style: "width:210px",
          sortable: true,
        },
        {
          name: "itemsInStock",
          align: "right",
          label: this.$t("products.qty"),
          field: "itemsInStock",
          style: "width:90px",
          sortable: true,
        },
        {
          name: "unit",
          align: "left",
          label: this.$t("products.unit"),
          field: "unit",
          style: "width:90px",
          sortable: true,
        },
      ],
      filter: "",
      products: [],
    };
  },

  computed: {
    //...mapState("main", ["articles"]),
  },

  methods: {
    onRowClick(evt, row) {
      console.log("clicked on", row);
      this.openProduct(row.id);
    },
    openProduct(productId) {
      console.log("clicked on", productId);
      router.push({
        name: "EditProduct",
        params: { id: productId },
      });
    },

    newProduct() {
      console.log("newProduct()");
      router.push({ name: "EditProduct", params: { id: 0 } });
    },

    async refresh() {
      console.log("refresh");
      this.products = await this.getArticles();
    },

    exportTable() {
 
    },
    ...mapActions("main", ["getArticles"]),
  },

  async created() {
    console.log("Products created");
    this.products = await this.getArticles();
  },
};
